import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Center } from '@mantine/core';
import Tilt from 'react-parallax-tilt';


const RewardStatus = (props) => {
    const dispatch = useDispatch();
    const epoch = useSelector(state => state.mainapp.stakingSlice.epoch)
    const stakingEarnedAmount = useSelector((state) => state.mainapp.stakingSlice.earnings)

    const stakedAt = useSelector((state) => state.mainapp.stakingSlice.stakingTime)
    const userIndex = useSelector((state) => state.mainapp.stakingSlice.userIndex)

    const taxReward = useSelector((state) => state.mainapp.stakingSlice.taxReward)
    const markerText = useMemo(() => {
        if (epoch.index === userIndex) {
            return 'Your turn';
        } else if (epoch.index > userIndex) {
            return 'Rewards Received';
        } else {
            return 'Upcoming Turn';
        }
    }, [epoch]);

    const stakeholderNotWaitList = useSelector(state => state.mainapp.stakingSlice.stakeholderNotWaitList)
    return (
        <>
            <div className='reward-status'>
                <div className='reward-status-text'>
                    {
                        stakeholderNotWaitList ? <h2>{
                            {
                                "Your turn": "Your turn",
                                "Rewards Received": "Rewards Received For This Epoch",
                                "Upcoming Turn": "Upcoming Turn"
                            }[markerText]
                        }
                        </h2> : <h2>Getting You Into Epoch</h2>
                    }

                    {
                        stakeholderNotWaitList ? <p>
                            {
                                {
                                    "Your turn": <>It's your turn in the epoch. <br /> You will receive rewards when the faucet is used.</>,
                                    "Rewards Received": <>You have already received your rewards. <br /> Wait for the next epoch to be initialized.</>,
                                    "Upcoming Turn": <>Your turn is upcoming. <br /> You will receive rewards after the faucet is used on your turn.</>
                                }[markerText]
                            }
                        </p> : 
                            epoch.start ?
                            <p className='loading-text'>Please wait until this epoch is complete before we can get you in.</p>
                            :
                            <p className='loading-text'>Please wait until the epoch is initialized.</p>
                    }
                </div>
                <div className='reward-status-data'>
                    <div className='charm-price'>
                        <i className='material-icons'>toll</i>
                        <div className='charm-price-text'>
                            <p>Staking Reward</p>
                            <h2>{
                                "+ " + (1).toLocaleString("en", { minimumFractionDigits: 2 })
                            }</h2>
                        </div>
                    </div>
                    <div className='small-charm-price'>
                        <p>Tax Reward</p>
                        <h2>{"+ " + taxReward.toLocaleString("en", { minimumFractionDigits: 2 })}</h2>
                    </div>
                </div>
            </div>

            <style>
                {
                    !stakeholderNotWaitList ? `
                        .reward-status-data {
                            opacity: 0.4;
                        }
                    ` : null

                }
            </style>
        </>
    );
};

export default RewardStatus
